import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import useAnalyticStore from '../analyticStore/useAnalyticStore';
import useApiStore from '../apiStore/useApiStore';
import useApplicantStore from '../applicantStore/useApplicantStore';
import useDashboardStore from '../dashboardStore/useDashboardStore';
import useUserStore from '../userStore/useUserStore';
import { getVerifications } from './functions/getVerifications';
import { keysToPersist, verificationStore } from './verificationStore';

const useVerificationStore = createStore({
  creator: verificationStore({
    getVerifications,
    useAnalyticStore: lazyDependency(() => useAnalyticStore),
    useApiStore: lazyDependency(() => useApiStore),
    useApplicantStore: lazyDependency(() => useApplicantStore),
    useDashboardStore: lazyDependency(() => useDashboardStore),
    useUserStore: lazyDependency(() => useUserStore),
  }),
  id: 'verification',
  middlewares: {
    devtools: true,
    persist: {
      partialize(state) {
        return pickState(state, keysToPersist);
      },
    },
  },
  persistHMR: true,
});

export default useVerificationStore;
